module.exports = __webpack_public_path__ + "static/media/maera_s25ru.95a17895.pdf";